<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/">
            <router-link to="/expenses/create" tag="button"
                         class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fas fa-plus mr-2"></i>
                Add Expense
            </router-link>
        </top-nav-bar>

        <list v-if="expenses.length">
            <list-item class="text-base sm:text-xl"
                       v-for="expense in expenses"
                       url="#"
                       :key="expense.id"
                       @click.native.prevent
                       @click="navigateTo(expense)">
                <template slot="icon">
                    <span class="text-center w-full">
                        <i class="fa" :class="findObjectStatusIconStyles(expense.status)"></i>
                    </span>
                </template>
                <template slot="title">
                    <span class="relative">
                        {{expense.type_name}}
                        <span class="h-4 flex -mr-4 absolute pin-t pin-r items-center justify-center bg-red rounded-full text-white text-xs px-1"
                              v-if="$hasNotification('expenses', expense.id).length > 0"
                              v-text="$hasNotification('expenses', expense.id).length"></span>
                    </span>
                </template>
                <template slot="sub-title" v-if="expense.date">
                    {{formatDate(expense.date, 'D MMM YYYY')}}
                </template>
                <template slot="status">
                    <span class="font-heading uppercase text-xs font-bold"
                          :class="findObjectStatusStyles(expense.status)">
                        {{expense.status.status}}
                    </span>
                </template>
            </list-item>
        </list>

        <empty :visible="!expenses.length">
            You have not submitted any expenses.
        </empty>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates'
    import ShowObjectStatus from '../mixins/ShowObjectStatus';
    import CanAccessView from '../mixins/CanAccessView';
    import NeedsExpenseFormTypes from '@/mixins/NeedsExpenseFormTypes'

    export default {
        mixins: [InteractsWithDates, ShowObjectStatus, CanAccessView, NeedsExpenseFormTypes],

        data() {
            return {
                loading: true,
                expenses: []
            }
        },

        computed: {},

        mounted() {
            this.$api('expenses').get('')
                .then(({data}) => {
                    this.expenses = data.data;
                    this.loading = false;
                })
        },

        methods: {

            navigateTo(expense) {
                this.processNotifications(expense);
                this.$router.push('/expenses/' + expense.id)
            },

            processNotifications(expense) {
                let notifications = this.$hasNotification('expenses', expense.id);

                if (notifications.length > 0) {
                    notifications.forEach(notification => this.$notificationRead(notification));
                }
            }
        },
    }
</script>
